import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import './VerdictArea.css';
import { INSPECTION_STATUS_VERDICT } from '../../utils/constants';
import ApproveRejectButtons from '../ApproveRejectButtons';

const { PENDING, IN_PROGRESS, APPROVED, REJECTED } = INSPECTION_STATUS_VERDICT;

const VerdictArea = ({ 
    verdict, 
    onVerdictChange, 
    comments, 
    onCommentsChange, 
    state = PENDING,
    onStart,
    onApprove,
    onReject,
    enableStartButton = false,
    enableApproveRejectButtons = false,
    rejectedPhotosCount = 0,
}) => {
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);

    const inspectionItems = [
        {
            id: 'chassis',
            label: 'Nº de Chasis',
            options: ['Original', 'Regrabado', 'Removido', 'Alterado', 'No porta', 'Otro'],
            required: true
        },
        {
            id: 'engine',
            label: 'Nº de Motor',
            options: ['Original', 'Regrabado', 'Removido', 'Alterado', 'No porta', 'Otro'],
            required: true
        },
        {
            id: 'serialPlate',
            label: 'Plaqueta Serial Número',
            options: ['Original', 'Regrabado', 'Removido', 'Alterado', 'No porta', 'Otro'],
            required: true
        },
        {
            id: 'productionConsecutive',
            label: 'Consecutivo Producción',
            options: ['Removido', 'No porta', 'Otro'],
            required: false
        },
        {
            id: 'transitLicense',
            label: 'Licencia de Tránsito',
            options: ['Original', 'No Original'],
            required: false
        }
    ];

    const handleVerdictClick = (itemId, option) => {
        if (state === IN_PROGRESS) {
            onVerdictChange(itemId, option);
        }
    };

    const handleCommentsChange = (e) => {
        if (state === IN_PROGRESS) {
            onCommentsChange(e.target.value);
        }
    };

    // Función para verificar si todos los campos obligatorios están completados
    const areRequiredFieldsComplete = () => {
        const requiredItems = inspectionItems.filter(item => item.required);
        return requiredItems.every(item => verdict[item.id] && verdict[item.id].trim() !== '');
    };

    const handleApproveClick = () => {
        if (state === IN_PROGRESS) {
            if (!areRequiredFieldsComplete()) {
                alert('Por favor, selecciona todas las opciones requeridas antes de aprobar.');
                return;
            }
            setConfirmAction(APPROVED);
            setShowConfirmModal(true);
        }
    };

    const handleRejectClick = () => {
        if (state === IN_PROGRESS) {
            if (!areRequiredFieldsComplete()) {
                alert('Por favor, selecciona todas las opciones requeridas antes de rechazar.');
                return;
            }
            setConfirmAction(REJECTED);
            setShowConfirmModal(true);
        }
    };

    const handleConfirmAction = () => {
        if (confirmAction === APPROVED) {
            onApprove();
        } else if (confirmAction === REJECTED) {
            onReject();
        }
        setShowConfirmModal(false);
        setConfirmAction(null);
    };

    const handleCancelModal = () => {
        setShowConfirmModal(false);
        setConfirmAction(null);
    };

    const isDisabled = !enableApproveRejectButtons;

    return (
        <div className="verdict-area">
            <div className="verdict-items-container">
                {inspectionItems.map((item) => (
                    <div key={item.id} className="verdict-item">
                        <div className="item-label">
                            <span className="item-text">{item.label}</span>
                            {item.required && <span className="required-indicator">*</span>}
                        </div>
                        <div className="item-options">
                            {item.options.map((option) => (
                                <button
                                    key={option}
                                    className={`option-button ${verdict[item.id] === option ? 'selected' : ''}`}
                                    onClick={() => handleVerdictClick(item.id, option)}
                                    disabled={isDisabled}
                                >
                                    {option}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div className="verdict-footer">
                <div className="comments-section">
                    <label htmlFor="comments" className="comments-label">
                        Observaciones
                    </label>
                    <textarea
                        id="comments"
                        className="comments-textarea"
                        value={comments}
                        onChange={handleCommentsChange}
                        placeholder="Escribe tus observaciones aquí..."
                        rows={6}
                        disabled={isDisabled}
                    />
                </div>

                <div className="verdict-actions">
                    {enableStartButton && (
                        <button 
                            className="start-button"
                            onClick={onStart}
                        >
                            Iniciar
                        </button>
                    )}
                    <ApproveRejectButtons
                        enableApproveButtons={enableApproveRejectButtons}
                        enableRejectButtons={enableApproveRejectButtons}
                        handleApproveClick={handleApproveClick}
                        handleRejectClick={handleRejectClick}
                        areRequiredFieldsComplete={areRequiredFieldsComplete}
                    />
                </div>
            </div>

            {/* Modal de confirmación */}
            <Modal
                isOpen={showConfirmModal}
                onClose={handleCancelModal}
                title={`Confirmar ${confirmAction === APPROVED ? 'Aprobación' : 'Rechazo'}`}
            >
                <div className="modal-content">
                    <p>
                        ¿Estás seguro de que deseas {confirmAction === APPROVED ? 'aprobar' : 'rechazar'} el área de dictamen?
                    </p>
                    
                    {(rejectedPhotosCount > 0) && (
                        <div className="modal-warning">
                            <p><strong>Advertencia:</strong></p>
                            <p>
                                Existen {rejectedPhotosCount} foto(s) rechazada(s).
                            </p>
                            <p>
                                Al finalizar la inspección, las fotos pendientes de revisión se aprobarán automáticamente.
                            </p>
                        </div>
                    )}
                    
                    <p className="modal-warning">
                        Esta acción no se puede deshacer.
                    </p>
                    <div className="modal-actions">
                        <button 
                            className="modal-button cancel-button"
                            onClick={handleCancelModal}
                        >
                            Cancelar
                        </button>
                        <button 
                            className={`modal-button ${confirmAction === APPROVED ? 'verdict-approve-button' : 'verdict-reject-button'}`}
                            onClick={handleConfirmAction}
                        >
                            {confirmAction === APPROVED ? 'Aprobar' : 'Rechazar'}
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default VerdictArea;